import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CTAButtonProps = {
  label: string;
  subtext?: string;
  className?: string;
  shake?: boolean;
  compact?: boolean;
};
export function CTAButton({
  label,
  subtext,
  className = "",
  shake = false,
  compact = false
}: CTAButtonProps) {
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-29" data-mp="2fya5jbo88z58">
      <a href={CHECKOUT_URL} className={`group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta text-center font-extrabold uppercase leading-tight text-white shadow-[0_6px_0_0_#167A42] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-cta-dark active:translate-y-[3px] active:shadow-[0_3px_0_0_#167A42] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${compact ? "px-5 py-3.5 text-base" : "px-5 py-5 text-lg sm:text-xl"} ${shake ? "animate-cta-shake" : ""}`} data-id="element-30" data-mp="2ty1qjwd5vfsq">
        <span data-id="element-31" data-mp="199oeofrmx7sr">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="19a7u9pttbk3m" />
      </a>
      {subtext && <p className="mt-3 max-w-md text-center text-sm text-muted" data-id="element-33" data-mp="1i8td7m37514x">{subtext}</p>}
    </div>;
}